import { makeAutoObservable } from 'mobx';
import { Dokument } from '@codefluegel/wowis-rest-typescript-client';

export default class DocumentsStore {
  private userDocuments: Dokument[] | undefined;

  public currentEstateId: number | undefined;

  constructor() {
    makeAutoObservable(this);
  }

  getUserDocuments(): Dokument[] | undefined {
    return this.userDocuments;
  }

  setUserDocuments(userDocuments: Dokument[]): void {
    this.userDocuments = userDocuments;
  }

  addUserDocument(userDocument: Dokument): void {
    this.userDocuments?.push(userDocument);
  }
}
